import React from 'react';
import RecordsTable from './RecordsTable';
import { beneficiariesMock } from './mockData';

const COLUMNS = [
  { field: 'BenID', header: 'ID' },
  { field: 'Member_ID', header: 'Member ID' },
  { field: 'BenName', header: 'First Name' },
  { field: 'BenSurname', header: 'Surname' },
  { field: 'BenDOB', header: 'Date Of Birth' },
  { field: 'BenRelation', header: 'Relationship' },
  { field: 'BenTelephone', header: 'Phone' },
];

const BeneficiariesTable = () => (
  <RecordsTable title="Beneficiaries" exportName="Beneficiaries" columns={COLUMNS} rows={beneficiariesMock} />
);

export default BeneficiariesTable;
